"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryExecutor = void 0;
const util = __importStar(require("util"));
const uuid_1 = require("uuid");
const constants_1 = require("./constants");
class QueryExecutor {
    constructor() {
        this.errorResponse = { status: 500, data: 'Internal Server Error' };
        this.currentRequestId = '';
        this.handler = {
            onSearch: () => { },
            onFailure: () => { },
            onFinish: () => { },
            onHit: () => { },
            onStart: () => { }
        };
        this.finishReason = { code: 0, reasonText: '' };
        this.shouldCheckRequestId = true;
    }
    execute(queryController, handler) {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentRequestId = (0, uuid_1.v4)();
            // eslint-disable-next-line no-prototype-builtins
            if (handler.hasOwnProperty('onSearch')) {
                this.handler = handler;
            }
            else {
                // @ts-ignore
                this.handler = handler.current.getHandler();
            }
            const method = queryController.getMethod();
            const body = this.getSearchBody(queryController);
            const headers = new Headers(queryController.props.headers);
            headers.delete(constants_1.X_SEARCH_ID_HEADER);
            headers.append(constants_1.X_SEARCH_ID_HEADER, this.currentRequestId);
            headers.append(constants_1.ACCEPT_ENCODING_HEADER, 'gzip');
            headers.append(constants_1.ACCEPT_HEADER, queryController.isStreamed() ? constants_1.STREAMJSON_CONTENT_TYPE : constants_1.JSON_CONTENT_TYPE);
            if (method === constants_1.SEARCH_METHOD_POST) {
                headers.append(constants_1.CONTENT_TYPE_HEADER, constants_1.JSON_CONTENT_TYPE);
            }
            if (method === constants_1.SEARCH_METHOD_OPEN) {
                headers.append(constants_1.CONTENT_TYPE_HEADER, constants_1.JSON_CONTENT_TYPE);
                headers.append(constants_1.X_RESPONSE_VERSION_HEADER, 'latest');
            }
            this.shouldCheckRequestId = queryController.shouldCheckRequestId();
            return fetch(queryController.getUrl(), {
                headers,
                body,
                method: method === constants_1.SEARCH_METHOD_OPEN ? constants_1.SEARCH_METHOD_POST : method,
            })
                .then((response) => __awaiter(this, void 0, void 0, function* () {
                this.handler.onSearch(queryController.getStates());
                if (queryController.isStreamed()) {
                    this.streamedSearch(response);
                }
                else {
                    this.requestResponseSearch(response);
                }
            }))
                .catch(data => {
                this.fail(Object.assign(Object.assign({}, this.errorResponse), { data }));
            });
        });
    }
    cancel() {
        this.currentRequestId = '';
    }
    getSearchBody(queryController) {
        switch (queryController.getMethod()) {
            case constants_1.SEARCH_METHOD_POST:
                return JSON.stringify(JSON.stringify(queryController.getJSON()));
            case constants_1.SEARCH_METHOD_OPEN:
                return JSON.stringify(queryController.getOpenSearchQuery());
            default:
                return undefined;
        }
    }
    requestResponseSearch(response) {
        const requestId = this.shouldCheckRequestId ? response.headers.get(constants_1.X_SEARCH_ID_HEADER) : this.currentRequestId;
        if (requestId) {
            if (this.currentRequestId === requestId) {
                response
                    .json()
                    .then(data => {
                    this.handler.onStart({ aggregations: data.aggregations, totalHits: data.totalHits });
                    if (this.handleHits(data.hits, requestId)) {
                        this.handler.onFinish(this.finishReason);
                    }
                })
                    .catch(() => this.fail({ status: 500, data: 'An error occurred while parsing the response' }));
            }
            else {
                this.handler.onFinish({ code: 2, reasonText: `${constants_1.X_SEARCH_ID_HEADER} changed` });
            }
        }
        else {
            this.fail({ status: 401, data: `Response returned without a ${constants_1.X_SEARCH_ID_HEADER}` });
        }
    }
    handleHits(hits, requestId) {
        let success = true;
        for (const hit of hits) {
            if (requestId !== this.currentRequestId) {
                success = false;
                if (this.currentRequestId === '') {
                    this.handler.onFinish({ code: 1, reasonText: 'search cancelled' });
                }
                else {
                    this.handler.onFinish({ code: 2, reasonText: 'x-request-id changed' });
                }
                break;
            }
            this.handler.onHit(hit);
        }
        return success;
    }
    handleStreamLine(data) {
        switch (data.type) {
            case 'begin':
                this.handler.onStart(data.value);
                break;
            case 'end':
                this.handler.onFinish(this.finishReason);
                break;
            default:
                this.handler.onHit(data.value);
                break;
        }
    }
    streamedSearch(response) {
        switch (true) {
            case response.status !== 200:
                response.text().then(data => this.fail({ status: response.status, statusText: response.statusText, data }), data => this.fail(Object.assign(Object.assign({}, this.errorResponse), { data })));
                break;
            // @ts-ignore
            case !response.headers:
            case !response.body:
                this.fail({ status: 400, data: 'Bad Request' });
                break;
            case !response.headers.get(constants_1.X_SEARCH_ID_HEADER):
            case this.currentRequestId !== response.headers.get(constants_1.X_SEARCH_ID_HEADER):
                return;
            default:
                try {
                    let read;
                    let dataBuffer = '';
                    let data;
                    const decoder = typeof TextDecoder !== 'undefined' ? new TextDecoder() : new util.TextDecoder();
                    // @ts-ignore
                    const requestId = response.headers.get(constants_1.X_SEARCH_ID_HEADER);
                    // @ts-ignore
                    const reader = response.body.getReader();
                    reader
                        .read()
                        .then((read = ({ done, value }) => {
                        if (requestId === this.currentRequestId) {
                            if (!done) {
                                data = dataBuffer + decoder.decode(value, { stream: true });
                                data.split('\n').forEach((line) => {
                                    dataBuffer = line;
                                    try {
                                        this.handleStreamLine(JSON.parse(dataBuffer));
                                        dataBuffer = '';
                                    }
                                    catch (_a) {
                                    }
                                });
                                reader.read().then(read);
                            }
                        }
                        else {
                            if (this.currentRequestId === '') {
                                this.handler.onFinish({ code: 1, reasonText: 'search cancelled' });
                            }
                            else {
                                this.handler.onFinish({ code: 2, reasonText: `${constants_1.X_SEARCH_ID_HEADER} changed` });
                            }
                            reader.cancel(this.finishReason.reasonText);
                        }
                    }))
                        .catch(e => this.fail(Object.assign(Object.assign({}, this.errorResponse), { data: e.message })));
                }
                catch (e) {
                    return this.fail(Object.assign(Object.assign({}, this.errorResponse), { data: e.message }));
                }
        }
    }
    fail(error) {
        this.handler.onFailure(error);
        this.handler.onFinish({ code: 3, reasonText: error.data });
    }
}
exports.QueryExecutor = QueryExecutor;
